
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { Sample } from '../../components';

@Component({
    selector: 'app-tooltips',
    imports: [Sample, MatTooltipModule],
    templateUrl: './tooltips.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './tooltips.scss'
})
export class Tooltips {}
